import type { Revision } from '../types';
import type { YRevision } from './revisionToY';

/**
 * Check if a YRevision is not broken.
 * For now, it only checks if the revision has all the required keys at the top level.
 */
export function checkYRevision(yRevision: YRevision) {
    const requiredKeys: Array<keyof Revision> = [
        'id',
        'contentId',
        'pages',
        'files',
        'rootPages',
        'parents',
    ];
    requiredKeys.forEach((key) => {
        if (!yRevision.has(key)) {
            throw new YRevisionCheckFail(`Missing revision key: ${key}`);
        }
    });
}

export class YRevisionCheckFail extends Error {
    constructor(message: string) {
        super(`YRevisionCheckFail: ${message}`);
    }
}
